<template>
	<ProductAttributes :blok="blok" />
</template>

<script setup lang="ts">
import ProductAttributes from "~/templates/gotaplatsensfoto/components/Product/ProductAttributes/ProductAttributes.vue";
import type { ProductAttributes as ProductAttributesBlok } from "~/types/storyblok/storyblok";

interface Props {
	blok: ProductAttributesBlok;
}
const { blok } = defineProps<Props>();
</script>
